import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { channelFetcher } from "../api/requests";
import { ProfileContext } from "./profile";
import { use } from "react";

const ChannelContext = createContext();

const ChannelContextProvider = ({ children }) => {
  const [channels, setChannels] = useState({});
  const [isLoadingUserChannels, setIsLoadingUserChannels] = useState(true);
  const [userChannels, setUserChannels] = useState();
  const { profile } = useContext(ProfileContext);
  const [isLoadingChannels, setIsLoadingChannels] = useState(false);

  const updateChannels = useCallback((newData) => {
    setChannels(newData);
  }, []);

  const getUsersChannels = useCallback(async () => {
    if (profile.user) {
      setIsLoadingUserChannels(true);
      try {
        const channels = await channelFetcher.getUserChannels(profile.user);
        setUserChannels(channels);
      } catch (error) {
        console.error("Error fetching user channels:", error);
      } finally {
        setIsLoadingUserChannels(false);
      }
    }
  }, [profile.user]);

  useEffect(() => {
    setIsLoadingChannels(true);
    const getChannels = async () => {
      try {
        setChannels(await channelFetcher.getConfirmedChannels());
      } catch (err) {
        console.error(err);
      } finally {
        setIsLoadingChannels(false);
      }
    };

    getChannels();
  }, []);

  useEffect(() => {
    if (profile.user) getUsersChannels();
  }, [profile.user, getUsersChannels]);

  const contextValue = useMemo(
    () => ({
      channels,
      updateChannels,
      getUsersChannels,
      userChannels,
      isLoadingUserChannels,
      isLoadingChannels,
    }),
    [channels, userChannels, isLoadingUserChannels, isLoadingChannels]
  );

  return (
    <ChannelContext.Provider value={contextValue}>
      {children}
    </ChannelContext.Provider>
  );
};

export { ChannelContext, ChannelContextProvider };
